import { render, staticRenderFns } from "./BuscarDominio.vue?vue&type=template&id=5bd7c8a8&scoped=true&"
import script from "./BuscarDominio.vue?vue&type=script&lang=js&"
export * from "./BuscarDominio.vue?vue&type=script&lang=js&"
import style0 from "./BuscarDominio.vue?vue&type=style&index=0&id=5bd7c8a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd7c8a8",
  null
  
)

export default component.exports